<template>
	<div class="pill-select">

		<div class="pill-select__title">
			{{ title }}
		</div>

		<div class="pill-select__container">
			<div 
				v-for="option in options" 
				:key="option.id"
				class="pill-select__pill"
				:class="{ active: selected.includes(option.id) }"
				@click="selectOption(option.id)"
				>
				{{ option.name }}
			</div>
		</div>

	</div>
</template>

<script>

export default {
	props: {
		modelValue: {
			type: [Array, String, Number],
			default: [],
			required: false
		},
		title: {
			type: String,
			required: true
		},
		options: {
			type: Array,
			required: true
		},
		singleSelectOnly: {
			type: Boolean,
			default: false
		}
	},
	emits: ['update:modelValue'],
	data: () => {
		return {
			selected: []
		}
	},
	mounted() {
		this.selected = this.modelValue
	},
	methods: {
		selectOption(id){
			if(this.singleSelectOnly){
				this.selected = [id]
			} else {

				if(this.selected.includes(id)){
					this.selected = this.selected.filter(item => item !== id)
				} else {
					this.selected.push(id)
				}
			}

			this.$emit('update:modelValue', this.selected)
		}
	
	},
	watch: {
		modelValue(newVal){
			this.selected = newVal
		}
	}
}

</script>

<style lang="sass" scoped>

.pill-select
	color: #fff
	padding: 10px
	border-radius: 5px
	background-color: #222
	border: 1px solid #333

	&__title
		font-family: 'Roboto Condensed', sans-serif
		font-weight: 700
		font-size: 16px
		line-height: 1.1
		color: #fff
		margin-bottom: 15px

	&__container
		display: flex
		flex-wrap: wrap
		gap: 10px

	&__pill
		background: #333
		padding: 6px 12px
		border-radius: 5px
		cursor: pointer
		transition: all 200ms
		border: 1px solid #666

		&:hover
			background: #444

		&.active
			background: #5AAE4B
			border: 1px solid #4A9C3F
			

</style>